import React from 'react';
import EditBtn from '../editBtn/EditBtn';
import {t} from 'react-switch-lang';

export default function FormActionButtons({
                                            isReview,
                                            edit,
                                            disabled,
                                            isLastCycle,
                                            isEditAllowedByStatus,
                                            userCanVerifyForm,
                                            canVerify,
                                            toggleVerifyModal,
                                            setDisabled
                                          }) {
  const canShowEditBtn =
    isReview && edit && disabled && isLastCycle && isEditAllowedByStatus;

  const canShowVerifyBtn =
    edit &&
    disabled &&
    isLastCycle &&
    userCanVerifyForm &&
    isEditAllowedByStatus &&
    canVerify;

  if (!canShowEditBtn && !canShowVerifyBtn) return null;

  return (
    <div className="d-flex justify-content-end">
      {canShowEditBtn && <EditBtn setDisabled={setDisabled} />}
      {canShowVerifyBtn && (
        <button type="button" className="primary-btn" onClick={toggleVerifyModal}>
          {t('buttons.verifyBtn')}
        </button>
      )}
    </div>
  );
}
